import { Spinner } from "reactstrap";

const SpinnerComponent = (props) => {
  const { size } = props;
  return <Spinner animation="border" size={size} />;
};

export default SpinnerComponent;
